import { toastService } from "src/libraries/toast";
import { getNltdevskeletonsUseCase } from "./getNltdevskeletonsUseCase";
import { appStateModel } from "src/entities/appState/AppStateModel";
import { nltdevskeletonsService } from "../entity/nltdevskeletons/NltdevskeletonsService";

export const deleteNltdevskeletonUseCase = async (id: number) => {
    try {
        appStateModel.isLoading = true;
        const response = await nltdevskeletonsService.delete(id);
        if (response?.isError) {
            toastService.onError('Some error');
        } else {
            await getNltdevskeletonsUseCase();
        }
    } catch (error) {
        console.warn('deleteNltdevskeletonUseCase: ', error);
    } finally {
        appStateModel.isLoading = false;
    }
}   